import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateDatevAccountDtoGen,
  MrfiktivImportDatevAccountDtoGen,
  MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen,
  MrfiktivPartnerDatevAccountViewModelGen
} from "../v1/data-contracts";
import { DatevAccount } from "../v1/DatevAccount";

/**
 * Communicate with API
 */
class DatevAccountService {
  mrfiktivProxy: DatevAccount;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new DatevAccount(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create an account
   */
  async create(
    partnerId: string,
    data: MrfiktivCreateDatevAccountDtoGen
  ): Promise<MrfiktivPartnerDatevAccountViewModelGen> {
    const contract = (await this.mrfiktivProxy.partnerDatevAccountControllerCreate(partnerId, data)).data;

    return contract;
  }

  /**
   * Import all datev accounts
   */
  async import(
    partnerId: string,
    data: MrfiktivImportDatevAccountDtoGen
  ): Promise<MrfiktivPartnerDatevAccountViewModelGen[]> {
    const contracts = (await this.mrfiktivProxy.partnerDatevAccountControllerImport(partnerId, data)).data;

    return contracts;
  }

  /**
   * Gets one page of DATEV accounts for a partner.
   */
  async get(data: MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen) {
    const accounts = await this.mrfiktivProxy.partnerDatevAccountControllerFindAllByPartnerId(data);

    return accounts.data;
  }

  /**
   *
   * @param partnerId
   */
  async sync(partnerId: string) {
    await this.mrfiktivProxy.partnerDatevAccountControllerSync(partnerId);
  }
}

/**
 * Communicate with  API
 */
export default new DatevAccountService(new MrfiktivHttpClientProvider());
